// src/data/tool88TraceThroughEntityCatalog.generated.js
//
// Shipped/default trace-through entities for Tool 88.
// Tool88Page.vue imports TOOL88_SHIPPED_TRACE_THROUGH_ENTITIES and normalizes
// each row into { id, canonicalName, aliases, addresses, notes, source }.
//
// Matching behavior in Tool 88:
// - `canonicalName` and `aliases` are exact normalized attribution-label matches.
// - `addresses` are exact selected-address matches.
// - User-added browser overrides can hide a shipped row by `id`, or replace it
//   with a custom row using the same `id`.
//
// Keep this file as a flat array. Do not wrap it in { field: "data" }.

export const TOOL88_SHIPPED_TRACE_THROUGH_ENTITIES = Object.freeze([
  {
    id: "personal-wallet",
    canonicalName: "Personal Wallet",
    aliases: [
      "Personal Wallet",
      "Private Wallet",
      "Individual Wallet",
      "Self-Custody Wallet",
      "Self Custody Wallet",
      "Self-Hosted Wallet",
      "Self Hosted Wallet",
    ],
    addresses: [],
    notes: "Address-owned wallet label; trace through unless Tool 88 hard safety checks block it.",
  },
  {
    id: "ens-address-owned-wallet",
    canonicalName: "ENS / Address-owned Wallet",
    aliases: [
      "ENS",
      "ENS Wallet",
      "ENS Name",
      "Address-owned ENS",
    ],
    addresses: [],
    notes: "Domain-style / address-owned attribution that should be treated as trace-through-friendly.",
  },
  {
    id: "manual-trace-through-approved",
    canonicalName: "Manual Trace-Through Approved",
    aliases: [
      "Trace Through Approved",
      "Trace-Through Approved",
      "Manual Trace Through",
      "Manual Trace-Through",
      "Trace Through Entity",
      "Trace-Through Entity",
    ],
    addresses: [],
    notes: "Operational label for user-reviewed private/self-custody entities that should continue tracing.",
  },
  {
    id: "prince-group",
    canonicalName: "Prince Group",
    aliases: [
      "Prince Group",
      "The Prince Group",
      "Prince",
      "PrinceGroup",
    ],
    addresses: [
      // Add exact addresses only when they are confirmed trace-through targets.
     "bc1qeth6n6ryxexvkx34wnx3nuynun4474h3j0gkhw",
       "bc1q2we5eqjj8je6lz9xwjattpc3pn4jejc5h0s70f",
     "bc1qnujzvts45qka3cr2eqqw8ur3q6g6s0ze2wlk5m",
     "bc1qw4fxztd5u3sl7vrcqwk2a8v5zh5dllvckx3tlt",
     "3EynPFpoGTPxU9m5bPaEDEUxUanzh7vgQP",
     "3FoD1f6Tfnq3s8MYHgJqFPWv9cUrtUdBSv",
     "3MKXKqPX6VxTLkVSXuDKzaTiZZaz5AmiK",
     "386sPhHBbLidzPnoxUH74jiiYkHYTobefQ",
     "35irs2AU6pVgenYbWvMRz22avDBLC9XMkd",
     "36ia8qAE1k1PKQePdXENCm1YKLXxZyVnnc",
     "374RguZDMNW5Zh5ouW3KhKDcrerKusmsuk",
     "3CuqLrZW5oCe6DRScdSwiFv8txcahrsG3",
     "3MNWiGeoKAhtTrbJuUXpvSRYJSvmyJSWE",
     "39HJB4x6W5QuKFEuV1tfcfNveLRJTzc12",
     "3L1PSCgfPKJAfQCZcoKfbvWf1fBwM1Bbs",
     "3D44E2Z3PcLa868GeBNiP5E2GPTfVLULUJ",
     "bc1qnq3pzsw3elkecrw8pqrz70r7zuse6cwyxa6dhc",
     "bc1qeaxuj8vamvnxqveleaqgmae33x904xuzj836p3",
     "bc1q66y45cq78ke25kz7rpe9l84avt7zetglzeeqg",
     "bc1qu8mcqffx3jpdwnap88h85u5l5l0xq97438tz2x",
     "bc1qw75cxmx4e2v265mue9wmqgq2m0qdyr25l2ufl",
     "bc1q7des766x6c0zkycz6dz6rfv066n3fcg4kggtrt",
     "bc1qlwtksgusw3pp3k3a39mkmwvswujhhgn0ulp3uj",
     "bc1qu4p4eynzu8vwwcv0yxq74gth00exjyech05uf0",
     "bc1qw0pswznckx7s6tjmd2f5hrx4q6kc5nyrdxku50",
     "bc1q9kja7t2zx0ze4lcgxf0l07pygpc69ws528lj9",
     "bc1qea942uw640l7nvtf3vplv6jd6wvuy06c58cd4k",
     "bc1q6qze6uj6jncgnva4eghxn3tr4pm2frh77ad3k9",
     "bc1qcx8vxxrld2s7qvz64qp75s3508rkzaxj65l60q",
      // "TXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX",
      // "bc1qexample...",
    ],
    notes: "Template row only. Replace with real shipped entity data or remove before production.",
  },
  {
    id: "example-entity-replace-me",
    canonicalName: "Example Entity Replace Me",
    aliases: [
      "Example Entity",
      "ExampleEntity",
      "Example_Entity",
      "The Example Entity",
    ],
    addresses: [
      // Add exact addresses only when they are confirmed trace-through targets.
      // "0x1234567890abcdef1234567890abcdef12345678",
      // "TXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX",
      // "bc1qexample...",
    ],
    notes: "Template row only. Replace with real shipped entity data or remove before production.",
  },
]);

export default TOOL88_SHIPPED_TRACE_THROUGH_ENTITIES;